import api2 from '@/services/api/my-pitstops.js'
import api from '@/services/api/status.js'
import titleCase from '@/utils/title-case'
import { immerable } from "immer"
import { useState } from 'react'

class Status {

	[immerable] = true

	constructor(params) {
		this.id = params.id
		this.name = params.name
		this.lastUpdated = params.lastUpdated
		this.image = params.image
	}
}

const useStatus = () => {

	const [items, setItems] = useState([])
	const [myPitstops, setMyPitstops] = useState([])
	const [currentItem ,setCurrentItem] = useState(null)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()

	async function fetch() {

		setLoading(true)

		const [errorResponse, data] = await api.index()

		setLoading(false)

		if (errorResponse) {
			return setError(errorResponse)
		}

		if (!Array.isArray(data)) {
			return setError('Status is not an array')
		}

		const serializedData = data.map(entry => serialize(entry))
		const newItems = serializedData.map(params => new Status(params))

		return setItems(newItems)
	}

	async function fetchMyPitstops() {

		setLoading(true)

		const [errorResponse, data] = await api2.index()

		setLoading(false)

		if (errorResponse) {
			return setError(errorResponse)
		}

		if (!Array.isArray(data)) {
			return setError('Status is not an array')
		}

		const serializedData = data.map(entry => serialize(entry))
		const newItems = serializedData.map(params => new Status(params))

		return setMyPitstops(newItems)
	}

	function serialize(entry) {

		const status = entry.status ? titleCase(entry.status) : null

		return {
			id: entry.id,
			name: entry.name,
			status: status,
			lastUpdated: entry.timestamp,
			image: entry.image
		}
	}

	function view(id) {
		const newCurrentItem = items.find(item => item.id === id)
		setCurrentItem(newCurrentItem)
	}

	return {
		error,
		fetch,
		fetchMyPitstops,
		items,
		myPitstops,
		currentItem,
		setCurrentItem,
		loading,
		setItems,
		view,
	}

}

export default useStatus
